export default __webpack_public_path__ + "static/media/schedule_transparent.c72b9dc4.svg";